import ERC721Abi from '../constants/sourceContract/abi/abiERC721.json';
import ERC721AAbi from "../constants/sourceContract/abi/abiERC721a.json";
import ERC1155Abi from '../constants/sourceContract/abi/abiERC1155.json';
import ERC20Abi from '../constants/sourceContract/abi/abiERC20.json';

const getContractAbi = (type) => {
    switch(type) {
        case "ERC721":
            return ERC721Abi
        case "ERC721A":
        case "ERC721PSI":
            return ERC721AAbi;
        case "ERC1155":
            return ERC1155Abi;
        case "ERC20":
            return ERC20Abi;
        default:
            return [];
    }
};

export {
    getContractAbi
}